import { Box, Grid, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleInfo } from "@fortawesome/pro-light-svg-icons"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikTextField } from "../../../../../../shared/components/forms/Formik"
import React from "react"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    infoWrap: {
        display: "grid",
        gridTemplateColumns: "0.875rem 1fr",
        background: theme.palette.tailwind.sky[50],
        borderRadius: "0.5rem",
        gap: "0.75rem",
        padding: "0.75rem",
        color: theme.palette.tailwind.sky[700],
        width: "100%",
    },
}))

export function MerchantContactDetails() {
    const { classes } = useStyles()

    return (
        <Grid container gap={2.5}>
            <Box className={classes.infoWrap}>
                <FontAwesomeIcon icon={faCircleInfo} />
                <LocalizedStrict id="create-or-edit-supplier-admin-merchant-contact-details-info">
                    <Typography variant="body2">Contact details will be public for the customers.</Typography>
                </LocalizedStrict>
            </Box>
            <LocalizedStrict
                id="create-or-edit-supplier-admin-merchant-field-contact-details-name"
                attrs={{ label: true }}
            >
                <FormikTextField name="contactDetails.name" label="Name" fullWidth />
            </LocalizedStrict>
            <LocalizedStrict
                id="create-or-edit-supplier-admin-merchant-field-contact-details-email"
                attrs={{ label: true }}
            >
                <FormikTextField name="contactDetails.email" label="Email" autoComplete="email" fullWidth />
            </LocalizedStrict>
            <LocalizedStrict
                id="create-or-edit-supplier-admin-merchant-field-contact-details-phone"
                attrs={{ label: true }}
            >
                <FormikTextField name="contactDetails.phoneNumber" label="Phone number" fullWidth />
            </LocalizedStrict>
        </Grid>
    )
}
